<div fxLayout="row" fxLayoutAlign="space-between center">
    <!-- hamburger menu icon -->
    <button class="menu" mat-icon-button [matMenuTriggerFor]="navMenu">
        <mat-icon>menu</mat-icon>
    </button>

    <!-- Navigation buttons -->
    <mat-menu #navMenu="matMenu">
        <ng-container *ngFor="let btn of filteredButtons">
            <a mat-menu-item [routerLinkActive]="'active'" [routerLink]="[btn.routerLink]"
                ><mat-icon [svgIcon]="btn.svgIcon"></mat-icon>{{ btn.name | translate }}</a
            >
        </ng-container>
    </mat-menu>

    <div fxFlex="100%" fxLayout="row" fxLayoutAlign="space-between center" class="topbar-content">
        <!-- kempower logo -->
        <div
            fxHide.xs
            fxLayout="row"
            fxLayoutAlign="start center"
            class="logo-container"
            [ngClass]="{ 'admin-section': sectionName }"
            fxLayoutGap="15px"
        >
            <!-- logo -->
            <img
                alt="kempower"
                [src]="
                    themeClass === 'theme-mykempower' ? 'assets/kempower-logo-inverse.svg' : 'assets/kempower-logo.svg'
                "
                class="logo logo-big"
                (click)="navigateToHome()"
                (keydown.enter)="navigateToHome()"
            />
            <!-- app name -->
            <span class="app-name" [ngClass]="{ 'mykempower-name': themeClass === 'theme-mykempower' }">
                {{ themeClass === 'theme-mykempower' ? 'MyKempower' : 'ChargEye' }}
            </span>
            <!-- section name -->
            <span class="section-name" *ngIf="sectionName">{{ sectionName }}</span>
        </div>

        <!-- Kempower logo without text for smaller screen sizes -->
        <img
            alt="kempower"
            fxHide.gt-xs
            src="assets/kempower-bullet-logo.svg"
            class="logo logo-small"
            (click)="navigateToHome()"
            (keydown.enter)="navigateToHome()"
        />

        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
            <!-- organization and license name -->
            <div fxFlex="100%" fxLayout="column" fxLayoutAlign="start end" class="topbar-description">
                <span class="ce-organization">{{ organizationName$ | async }}</span>
                <span class="ce-license">{{ licenseName$ | async | licenseName }}</span>
            </div>
        </div>
    </div>

    <!-- global search field -->
    <div
        class="search"
        fxLayoutAlign="center center"
        [class.active]="isSearchFieldActive$ | async"
        *ngIf="hasPermissionsToSearch$ | async"
    >
        <ce-search [themeClass]="themeClass" (searchFocused)="setSearchActive($event)"></ce-search>
    </div>
    <div class="timezone" fxLayoutAlign="space-between center">
        <!-- timezone selection -->
        <ce-time-display [themeClass]="themeClass"></ce-time-display>
    </div>
    <div class="release-note" fxLayoutAlign="center center">
        <ce-release-info [themeClass]="themeClass"></ce-release-info>
    </div>
    <div class="profile" fxLayoutAlign="center center">
        <ce-profile [themeClass]="themeClass"></ce-profile>
    </div>
</div>
